import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-short-long-description',
  templateUrl: './short-long-description.component.html',
  styleUrls: ['./short-long-description.component.scss'],
})
export class ShortLongDescriptionComponent implements OnChanges {
  @Input() description: string;

  @Input() descriptionLength = 160;
  @Input() descriptionLengthMobile = 80;

  public descriptionLengthByScreenSize: number;
  public isMobileSize = false;
  public isShowingFull = false;
  public isShowingToggleButton = false;

  constructor(private translate: TranslateService) {}

  ngOnChanges(changes: any): void {
    if (changes) {
      this.handleDescription();
    }
  }

  public handleDescription(): void {
    const MOBILE_SCREEN_SIZE_L = 425;

    this.isMobileSize = window.innerWidth <= MOBILE_SCREEN_SIZE_L;
    // ** Mobile size implementation
    if (this.isMobileSize && this.descriptionLengthMobile) {
      if (this.descriptionLengthMobile) {
        this.descriptionLengthByScreenSize = this.descriptionLengthMobile;
      }
    }
    // ** Desktop size implementation
    else {
      this.descriptionLengthByScreenSize = this.descriptionLength;
    }
    // ** Toggle button implementation
    if (this.descriptionLengthByScreenSize < this.description?.length) {
      this.isShowingToggleButton = true;
    }
  }

  public toggleDisplayingOption(): void {
    this.isShowingFull = !this.isShowingFull;
  }

  public get toggleButtonContent(): Observable<string> {
    return this.translate.instant(`long.short.description.show.${this.isShowingFull ? 'less' : 'more'}.button`);
  }
}
